"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressStepperStepLabelTextMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _typographyMixin = require("../typographyMixin");
var ProgressStepperStepLabelTextMixin = function ProgressStepperStepLabelTextMixin(props) {
  return (0, _styledToken.default)({
    fontType: 'ProgressStepper.labelFontType'
  }, function (_ref) {
    var fontType = _ref.fontType;
    return (0, _styledComponents.css)(["display:block;", ""], (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)));
  })(props);
};
exports.ProgressStepperStepLabelTextMixin = ProgressStepperStepLabelTextMixin;